'use client'

import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { type ReactNode, useEffect, useRef } from 'react'

import styles from './ContactModal.module.scss'

export const CONTACT_MODAL_ID = 'help-contact-modal'

interface ContactModalProps {
	isOpen: boolean
	children: ReactNode
	onClose: () => void
}

export function ContactModal({
	isOpen,
	children,
	onClose,
}: Readonly<ContactModalProps>) {
	const { t } = useLabels()
	const modalRef = useRef<ModalAPI>(null)

	useEffect(() => {
		if (isOpen) {
			modalRef.current?.show()
		}
	}, [isOpen])

	return (
		<Modal
			name={CONTACT_MODAL_ID}
			ref={modalRef}
			onClose={onClose}
			type={MODAL_TYPE.SIDE}
			data-testid='help.contact.modal'
			title={t('help.contact.header.title')}
			subtitle={
				<span className={styles.subtitle}>
					{t('help.contact.header.subtitle')}
				</span>
			}
			showTitle
		>
			{children}
		</Modal>
	)
}
